import { i18n } from "../services/i18nService";

const SELECTED_IMAGE = "selectedImage";
const BTN_DISCARD_CHANGES = "DISCARD_CHANGES";
const BTN_SAVE_CHANGES = "SAVE_CHANGES";
const BTN_KEEP_PROFILE = "KEEP_PROFILE";
const BTN_DELETE_PROFILE = "DELETE_PROFILE";
const BTN_CHANGE_PIN = "CHANGE_PIN";
const BTN_REMOVE_PIN = "REMOVE_PIN";
const BTN_CLOSE_POPUP = "CLOSE_POPUP";

export const MP_MODAL_TYPES = {
  MP_PROFILE_IMAGES_POPUP: "MULTI_PROFILE_IMAGE_POPUP",
  MP_VERTICAL_SIDEBAR_POPUP: "VERTICAL_SIDEBAR_POPUP"
};

const modalContentHeight = { fr: "small", ar: "medium", en: "large" };

export function showProfileImagesModal() {
  const {
    stateActions: { showGlobalModal },
    setFocus
  } = this.props;
  let avatarsList = [];
  avatarsList = [...this.state.profileImage.avatars];
  const profileImagesModalConfig = {
    type: MP_MODAL_TYPES.MP_PROFILE_IMAGES_POPUP,
    setFocus: setFocus,
    profileImage: this.state.profileImage,
    getSelectedAvatar: this.getSelectedAvatar,
    modalTitle: i18n.get("pages.editProfile.profileImagesModal.header"),
    modalText: i18n.get("pages.editProfile.profileImagesModal.subText")
  };
  let selectedImageIndex = avatarsList.findIndex(avatar => avatar.src === this.state.profileImage.currentAvatar);
  selectedImageIndex = selectedImageIndex < 0 ? 0 : selectedImageIndex;
  showGlobalModal(profileImagesModalConfig);
  setFocus(`${SELECTED_IMAGE}_${selectedImageIndex}`);
}

export function showMultiProfileLanguageModal(languageList, selectedLanguage) {
  const {
    stateActions: { showGlobalModal },
    setFocus
  } = this.props;
  let availableLanguages = [...languageList];
  availableLanguages = availableLanguages.map(lang => {
    return {
      ...lang,
      key: lang.languageCode,
      title: lang.title,
      focusPath: lang.title
    };
  });
  let currentLanguage =
    availableLanguages.length > 0 &&
    availableLanguages.find(
      item => item.languageCode === selectedLanguage.languageCode || item.languageCode === selectedLanguage.key
    );
  const languageModalConfig = {
    type: MP_MODAL_TYPES.MP_VERTICAL_SIDEBAR_POPUP,
    modalTitle: i18n.get("pages.editProfile.languageModal.header"),
    modalText: i18n.get("pages.editProfile.languageModal.subHeader"),
    isLanguageModel: true,
    modalTitleFontSize: "xxmedium",
    modalContentHeight: "0rem",
    setFocus: setFocus,
    onItemSelected: item => {
      const updatedItem = { ...item, languageCode: item.key };
      this.onChangeLanguage(updatedItem, availableLanguages);
      this.props.stateActions.hideGlobalModal();
    },
    langBtns: availableLanguages
  };
  showGlobalModal(languageModalConfig);
  setFocus(currentLanguage.title);
}

/// save changes modal config
export async function showSaveProfileChangesModal(onSaveChanges, onDiscardChanges) {
  const {
    stateActions: { showGlobalModal },
    setFocus
  } = this.props;
  const currentLang = i18n.getLocale();
  const saveProfileChangesConfig = {
    type: MP_MODAL_TYPES.MP_VERTICAL_SIDEBAR_POPUP,
    modalTitle: i18n.get("pages.editProfile.saveChangesModal.header"),
    modalText: i18n.get("pages.editProfile.saveChangesModal.subText"),
    modalTitleFontSize: "xxmedium",
    modalContentHeight: modalContentHeight[currentLang],
    modalHeadingTextLineHeight: "xxlarge",
    modalHeadingSpacing: "xxsmall",
    buttons: [
      {
        label: i18n.get("pages.editProfile.saveChangesModal.saveChangesCta"),
        focusPath: BTN_SAVE_CHANGES,
        buttonHandler: onSaveChanges
      },
      {
        label: i18n.get("pages.editProfile.saveChangesModal.discardChangesCta"),
        focusPath: BTN_DISCARD_CHANGES,
        buttonHandler: onDiscardChanges
      }
    ]
  };
  showGlobalModal(saveProfileChangesConfig);
  setFocus(saveProfileChangesConfig.buttons[0].focusPath);
  return saveProfileChangesConfig.buttons[0].focusPath;
}

/// delete profile modal config
export async function showDeleteProfileModal(onKeepProfile, onDeleteProfile) {
  const {
    stateActions: { showGlobalModal },
    setFocus
  } = this.props;
  const currentAvatar = this.state.profileImage
    ? this.state.profileImage.currentAvatar
    : this.props.profileImage.currentAvatar;
  let profileName = this.state.profileName && this.state.profileName;
  const deleteProfileModalConfig = {
    type: MP_MODAL_TYPES.MP_VERTICAL_SIDEBAR_POPUP,
    modalTitle: i18n.get("pages.editProfile.deleteProfileModal.header"),
    modalText: i18n.get("pages.editProfile.deleteProfileModal.subText"),
    modalText2: i18n.get("pages.editProfile.deleteProfileModal.subText"),
    modalTitleFontSize: "medium",
    modalHeadingTextLineHeight: "large",
    modalHeadingSpacing: "xsmall",
    modalIconSectionDisplay: "column",
    modalContentHeight: "medium",
    features: [
      {
        icon: currentAvatar,
        title: profileName,
        width: "10rem",
        height: "10rem",
        borderRadius: "50%",
        spacing: "small",
        boxShadow: "0 0 16px 0 rgba(0,0,0,0.24)"
      }
    ],
    buttons: [
      {
        label: i18n.get("pages.editProfile.deleteProfileModal.keepProfileCta"),
        focusPath: BTN_KEEP_PROFILE,
        buttonHandler: onKeepProfile
      },
      {
        label: i18n.get("pages.editProfile.deleteProfileModal.DeleteProfileCta"),
        focusPath: BTN_DELETE_PROFILE,
        buttonHandler: onDeleteProfile
      }
    ]
  };
  showGlobalModal(deleteProfileModalConfig);
  setFocus(deleteProfileModalConfig.buttons[0].focusPath);
}

/// show profile lock modal config
export async function showProfileLockModal(pin, profileName, onClickChange, onClickRemove, onClickCancel) {
  const {
    stateActions: { showGlobalModal },
    setFocus
  } = this.props;
  const profileLockModalConfig = {
    type: MP_MODAL_TYPES.MP_VERTICAL_SIDEBAR_POPUP,
    modalText: i18n.get("pages.editProfile.profileLockModal.subText", profileName),
    modalTitle: i18n.get("pages.editProfile.profileLockModal.header"),
    modalTitleFontSize: "xxmedium",
    iconWrapperMarginTop: "medium",
    isPinBox: true,
    modalContentHeight: "0rem",
    pin: pin,
    buttons: [
      {
        label: i18n.get("pages.editProfile.profileLockModal.changePinCta"),
        focusPath: BTN_CHANGE_PIN,
        buttonHandler: onClickChange
      },
      {
        label: i18n.get("pages.editProfile.profileLockModal.removePinCta"),
        focusPath: BTN_REMOVE_PIN,
        buttonHandler: onClickRemove
      },
      {
        label: i18n.get("global.cancel"),
        focusPath: BTN_CLOSE_POPUP,
        buttonHandler: onClickCancel
      }
    ]
  };
  showGlobalModal(profileLockModalConfig);
  setFocus(profileLockModalConfig.buttons[0].focusPath);
}
